import { Api } from "./api.service";

export function getRatingRequestStatusList() {
  return Api.get("/rating/request/status");
}

export function getCurrentSemester() {
  return Api.get("/semester/current");
}

export function getCurrentRating() {
  return Api.get("/rating/current");
}

export function createRating(semesterId) {
  return Api.post(`/semester/${semesterId}/rating`);
}

export function getRatingSumInfo(id) {
  return Api.get(`/rating/${id}/sum-info`);
}

export function updateRating(id, params) {
  return Api.put(`/rating/${id}`, params);
}

export function listActivityType() {
  return Api.get("/rating/activity-type");
}

export function getActivityTypesByRating(ratingId) {
  return Api.get(`/rating/${ratingId}/rating-activity-type`);
}

export function getActivityTypeInfoByRating(ratingId) {
  return Api.get(`/rating/${ratingId}/rating-activity-type-info`);
}

export function getUserRequestList(userId) {
  return Api.get(`/user/${userId}/rating-request`);
}

export function createRatingRequest(params) {
  return Api.post("/rating/request", params);
}

export function updateRatingRequest(id, params) {
  return Api.put(`/rating/request/${id}`, params);
}

export function deleteRatingRequest(id) {
  return Api.delete(`/rating/request/${id}`);
}

export function infoRatingRequest(id) {
  return Api.get(`/rating/request/${id}/info`);
}

export function createRatingActivityType(ratingId, params) {
  return Api.post(`/rating/${ratingId}/rating-activity-type`, params);
}

export function updateRatingActivityType(id, params) {
  return Api.put(`/rating/rating-activity-type/${id}`, params);
}

export function deleteRatingActivityType(id) {
  return Api.delete(`/rating/rating-activity-type/${id}`);
}

export function getRatingRules(ratingId) {
  return Api.get(`/rating/${ratingId}/rule-info`);
}

export function getEmptyRatingRules(ratingId) {
  return Api.get(`/rating/${ratingId}/rule-empty`);
}

export function createRatingRule(ratingId, params) {
  return Api.post(`/rating/${ratingId}/rule`, params);
}

export function updateRatingRule(id, params) {
  return Api.put(`/rating/rule/${id}`, params);
}

export function deleteRatingRule(id) {
  return Api.delete(`/rating/rule/${id}`);
}

export function ratingReport(id) {
  return Api.get(`/rating/${id}/report`);
}
